module.exports = __webpack_public_path__ + "img/lg_ring_y_s_null_null@2x.1f923212.png";